const page = (en, fr) => ({ en, fr });

export const LANDINGS_CLM = {
  "corporate-lifestyle-management-paris": page(
    {
      seoTitle: "Corporate Lifestyle Management in Paris | Book & Smile",
      seoDesc: "Corporate lifestyle management in Paris: client hospitality, executive visits, employee support and family office coordination — one local partner.",
      eyebrow: "Corporate Lifestyle Management · Paris",
      h1a: "Corporate lifestyle management",
      h1b: "in Paris.",
      answer: "Book & Smile provides corporate lifestyle management in Paris: one trusted local partner who handles client hospitality, executive visits, employee lifestyle support and family office coordination — under a single agreement, with monthly reporting.",
      s: "Your organisation's people touch Paris constantly: executives visiting, clients to host, assignees settling, principals whose personal logistics spill into the office.",
      c: "Handled ad hoc, this lifestyle layer consumes EA hours, HR patience and goodwill — and its quality varies with whoever improvised it last.",
      q: "What if the lifestyle layer had one accountable owner in Paris?",
      deliverablesTitle: "What we manage",
      deliverables: [
        "Client hospitality — dinners, gifts, experiences that close relationships",
        "Executive visit programmes — door-to-door, prepared and confirmed",
        "Employee lifestyle support — practical Paris assistance for staff and assignees",
        "Family office lifestyle support — principals' personal logistics, coordinated discreetly",
        "Events — offsites, board dinners, product moments",
        "One agreement — consolidated invoicing, monthly written reporting",
      ],
      forTitle: "Who retains us",
      forWho: [
        "International companies with recurring presence in Paris",
        "Family offices seeking lifestyle support for principals in France",
        "Executive offices and EAs who need a Paris execution arm",
      ],
      faqs: [
        { q: "What is corporate lifestyle management?", a: "The professional management of an organisation's lifestyle layer in a city — hospitality, executive visits, employee and principal support — by one accountable local partner rather than ad hoc improvisation." },
        { q: "How does this work with a family office?", a: "We act as the Paris lifestyle desk under the family office's direction: NDA by default, one named contact, written reporting to your operating standard." },
        { q: "How is it invoiced?", a: "A monthly corporate arrangement or per-mission quotes — terms defined in a private consultation." },
      ],
      waMsg: "Hello, I am interested in corporate lifestyle management in Paris.",
    },
    {
      seoTitle: "Corporate lifestyle management à Paris | Book & Smile",
      seoDesc: "Corporate lifestyle management à Paris : accueil de clients, visites de dirigeants, support des collaborateurs et coordination family office — un partenaire local.",
      eyebrow: "Corporate lifestyle management · Paris",
      h1a: "Corporate lifestyle management",
      h1b: "à Paris.",
      answer: "Book & Smile assure le corporate lifestyle management à Paris : un partenaire local de confiance qui gère l'accueil de vos clients, les visites de dirigeants, le support lifestyle des collaborateurs et la coordination family office — sous un accord unique, avec reporting mensuel.",
      s: "Les personnes de votre organisation touchent Paris en permanence : dirigeants en visite, clients à recevoir, collaborateurs en mission, principals dont la logistique personnelle déborde sur le bureau.",
      c: "Gérée au coup par coup, cette couche lifestyle consomme des heures d'assistantes, la patience des RH — et sa qualité varie selon qui a improvisé la dernière fois.",
      q: "Et si la couche lifestyle avait un responsable unique à Paris ?",
      deliverablesTitle: "Ce que nous gérons",
      deliverables: [
        "Accueil clients — dîners, cadeaux, expériences qui scellent les relations",
        "Programmes de visites dirigeants — porte à porte, préparés et confirmés",
        "Support lifestyle collaborateurs — assistance pratique à Paris",
        "Support lifestyle family office — logistique personnelle des principals, coordonnée discrètement",
        "Événements — séminaires, dîners de conseil, moments produits",
        "Un accord unique — facturation consolidée, reporting écrit mensuel",
      ],
      forTitle: "Qui nous retient",
      forWho: [
        "Sociétés internationales avec présence récurrente à Paris",
        "Family offices cherchant un support lifestyle pour leurs principals en France",
        "Directions et assistantes ayant besoin d'un bras d'exécution parisien",
      ],
      faqs: [
        { q: "Qu'est-ce que le corporate lifestyle management ?", a: "La gestion professionnelle de la couche lifestyle d'une organisation dans une ville — hospitalité, visites de dirigeants, support des collaborateurs et principals — par un partenaire local responsable plutôt que par improvisation." },
        { q: "Comment cela fonctionne-t-il avec un family office ?", a: "Nous agissons comme desk lifestyle parisien sous la direction du family office : NDA par défaut, contact nommé, reporting écrit à votre standard." },
        { q: "Comment est-ce facturé ?", a: "Accord corporate mensuel ou devis par mission — conditions définies en consultation privée." },
      ],
      waMsg: "Bonjour, je suis intéressé(e) par le corporate lifestyle management à Paris.",
    }
  ),
};
